module.exports = __webpack_public_path__ + "b668cf3bebe790e3de7a90623097cdd6.svg";